<template>
  <div id="create">
    <v-container fluid id="anpr-listing-view" class="px-2">
      <v-card elevation="4" color="#EFEBE9" class="px-3 pb-1">
        <v-form v-model="valid">
          <v-row>
            <v-col cols="6" md="2">
              <vdate
                label="From Date"
                :rules="reqRules"
                required
                v-model="fromDate"
              >
              </vdate>
            </v-col>
            <v-col cols="6" md="2">
              <vdate
                label="To Date"
                :rules="reqRules"
                required
                v-model="toDate"
                :value="toDate"
              >
              </vdate>
            </v-col>
            <v-col cols="6" md="1">
              <v-btn
                dense
                color="primary"
                @click="showData"
                block
                :disabled="!valid"
                :loading="tableLoading"
                rounded
                x-large
              >
                <v-icon> mdi-database-search </v-icon>
                Search
              </v-btn>
            </v-col>
            <v-col cols="6" md="7">
              <v-row dense v-for="item in legendData" :key="item.legendName">
                <v-col cols="4" md="10"> </v-col>
                <v-col cols="8" md="2">
                  <v-sheet
                    style="display: inline-block;"
                    :color="item.rowcolor"
                    elevation="1"
                    height="10"
                    width="20"
                  ></v-sheet>

                  <span style="display: inline-block; margin-left: 10px">{{
                    item.legendName
                  }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
      <v-card elevation="4" color="#EFEBE9" class="px-3 my-5">
        <v-row>
          <v-col cols="12">
            <v-tabs
              v-model="tab"
              background-color="warning"
              dark
              icons-and-text
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab>
                Active
                <v-icon>mdi-exclamation-thick</v-icon>
              </v-tab>

              <v-tab>
                Completed
                <v-icon>mdi-sticker-check-outline</v-icon>
              </v-tab>
              <v-tab v-if="userid.charAt(0) != 'U'">
                Missed
                <v-icon>mdi-call-missed</v-icon>
              </v-tab>
              <v-tab v-if="userid.charAt(0) != 'U'">
                Pending
                <v-icon>mdi-format-list-checks</v-icon>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" touchless>
              <v-tab-item>
                <v-data-table
                  :mobile-breakpoint="mobilebreakpoint"
                  :headers="headers"
                  :items="listingActive"
                  :items-per-page="10"
                  :search="search"
                  class="elevation-4 mt-2"
                  :footer-props="{
                    itemsPerPageOptions: [10, 20, 40, 80, -1],
                    'items-per-page-text': 'rows/page',
                  }"
                  :loading="tableLoading"
                  loading-text="Loading... Please wait"
                  :item-class="row_classes"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.lcT_DT="{ item }">
                    <span>{{ formatDate(item.lcT_DT, "DD-MMM-YY") }}</span>
                  </template>
                  <template v-slot:item.description="{ item }">
                    <span v-html="item.description"></span>
                  </template>
                  <template
                    v-slot:item.qName="{ item }"
                    v-if="userid.charAt(0) === 'U'"
                  >
                    <span v-if="item.qName === ''">{{ item.qName }}</span>
                    <a v-else @click="downloadfile(item.qName, 'Q')"
                      >Download</a
                    >
                  </template>
                  <template
                    v-slot:item.aName="{ item }"
                    v-if="userid.charAt(0) === 'U'"
                  >
                    <span v-if="item.aName === ''">{{ item.aName }}</span>
                    <a v-else @click="downloadfile(item.aName, 'A')"
                      >Download</a
                    >
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item touchless>
                <v-data-table
                  :mobile-breakpoint="mobilebreakpoint"
                  :headers="headers"
                  :items="listingCompleted"
                  :items-per-page="10"
                  :search="search2"
                  class="elevation-4 mt-2"
                  :footer-props="{
                    itemsPerPageOptions: [10, 20, 40, 80, -1],
                    'items-per-page-text': 'rows/page',
                  }"
                  :loading="tableLoading"
                  loading-text="Loading... Please wait"
                  :item-class="row_classes"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-text-field
                        v-model="search2"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.lcT_DT="{ item }">
                    <span>{{ formatDate(item.lcT_DT, "DD-MMM-YY") }}</span>
                  </template>
                  <template v-slot:item.description="{ item }">
                    <span v-html="item.description"></span>
                  </template>
                  <template
                    v-slot:item.qName="{ item }"
                    v-if="userid.charAt(0) === 'U'"
                  >
                    <span v-if="item.qName === ''">{{ item.qName }}</span>
                    <a v-else @click="downloadfile(item.qName, 'Q')"
                      >Download</a
                    >
                  </template>
                  <template
                    v-slot:item.aName="{ item }"
                    v-if="userid.charAt(0) === 'U'"
                  >
                    <span v-if="item.aName === ''">{{ item.aName }}</span>
                    <a v-else @click="downloadfile(item.aName, 'A')"
                      >Download</a
                    >
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item touchless>
                <v-data-table
                  :mobile-breakpoint="mobilebreakpoint"
                  :headers="headers"
                  :items="listingMissed"
                  :items-per-page="10"
                  :search="search3"
                  class="elevation-4 mt-2"
                  :footer-props="{
                    itemsPerPageOptions: [10, 20, 40, 80, -1],
                    'items-per-page-text': 'rows/page',
                  }"
                  :loading="tableLoading"
                  loading-text="Loading... Please wait"
                  :item-class="row_classes"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-text-field
                        v-model="search3"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.lcT_DT="{ item }">
                    <span>{{ formatDate(item.lcT_DT, "DD-MMM-YY") }}</span>
                  </template>
                  <template v-slot:item.description="{ item }">
                    <span v-html="item.description"></span>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab-item touchless>
                <v-data-table
                  :mobile-breakpoint="mobilebreakpoint"
                  :headers="headers"
                  :items="listingPending"
                  :items-per-page="10"
                  :search="search3"
                  class="elevation-4 mt-2"
                  :footer-props="{
                    itemsPerPageOptions: [10, 20, 40, 80, -1],
                    'items-per-page-text': 'rows/page',
                  }"
                  :loading="tableLoading"
                  loading-text="Loading... Please wait"
                  :item-class="row_classes"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-text-field
                        v-model="search3"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.lcT_DT="{ item }">
                    <span>{{ formatDate(item.lcT_DT, "DD-MMM-YY") }}</span>
                  </template>
                  <template v-slot:item.description="{ item }">
                    <span v-html="item.description"></span>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-card>

      <vconfirm
        :confirmOption="confirmBox"
        @isConfirm="isConfirm"
        :dialogConfirm="dialogConfirm"
        :confirmLoading="confirmLoading"
      >
      </vconfirm>
    </v-container>
  </div>
</template>
<style scoped>
.v-data-table {
  max-width: 100%;
}
</style>
<script>
import axios from "axios";
import { get, sync } from "vuex-pathify";
import vdate from "@/components/v-date";

import vconfirm from "@/components/v-confirm";
import download from "downloadjs";
import moment from "moment";
import { showSnackbar } from "../util/globalActions";
import { formatDate } from "../util/helpers";
export default {
  name: "TimetableView",
  components: { vdate, vconfirm },

  data: () => ({
    isExpanded: false,
    tab: null,
    validEdit: false,
    switchmobilebreakpoint: false,
    mobilebreakpoint: "200",
    confirmBox: {
      message: "",
      okCaption: "OK",
      cancelCaption: "Cancel",
      data: "",
    },
    dialogConfirm: false,
    confirmLoading: false,
    isConfirm: false,
    width: 700,
    tableLoading: false,
    loadingprofessor: false,
    valid: false,
    modal: false,
    fromDate: null,
    toDate: null,
    search: "",
    search2: "",
    search3: "",
    legendData: [],
    listingPending: [],
    listingMissed: [],
    listingCompleted: [],
    listingActive: [],
    message: "",
    professors: [],
    snackbar: false,
    reqRules: [(v) => !!v || "Field is required"],
    professor_id: null,
    headers: [],
  }),
  created() {
    this.headers = [];
    if (this.userid.charAt(0) === "U") {
      this.headers.push({
        text: "Date",
        value: "lcT_DT",
        width: "120px",
      });
      this.headers.push({
        value: "tS_TIMESLOT",
        text: "Time",
        width: "150px",
      });
      this.headers.push({
        value: "mins",
        text: "Mins",
        width: "100px",
      });
      this.headers.push({
        value: "brN_NAME",
        text: "Branch",
        width: "100px",
      });
      this.headers.push({
        value: "clR_SHORT_NAME",
        text: "Class",
        width: "100px",
      });
      this.headers.push({
        text: "Batch",
        value: "bcH_SHORT_NAME",
        width: "200px",
      });
      this.headers.push({ text: "Subject", value: "suB_NAME", width: "200px" });
      this.headers.push({
        text: "Topic",
        value: "description",
        width: "400px",
      });
      this.headers.push({
        text: "Question Paper",
        value: "qname",
        width: "100px",
      });
      this.headers.push({
        text: "Model Answer",
        value: "aname",
        width: "100px",
      });
      this.headers.push({
        text: "Type",
        value: "entryType",
        width: "200px",
      });      
      this.headers.push({
        text: "Last Attempt Date",
        value: "last_Attempt_Date",
        width: "200px",
      });      
    } else {
      this.headers.push({
        text: "Date",
        value: "lcT_DT",
        width: "120px",
      });
      this.headers.push({
        value: "tS_TIMESLOT",
        text: "Time",
        width: "150px",
      });
      this.headers.push({
        text: "Batch",
        value: "bcH_SHORT_NAME",
        width: "200px",
      });
      this.headers.push({ text: "Subject", value: "suB_NAME", width: "150px" });
      this.headers.push({
        text: "Description",
        value: "description",
        width: "400px",
      });

      this.headers.push({
        text: "Instructor",
        value: "usR_NAME",
        width: "200px",
      });
      this.headers.push({
        value: "clR_SHORT_NAME",
        text: "Classroom",
        width: "150px",
      });
      this.headers.push({ text: "TestId", value: "exM_ID", width: "80px" });
      this.headers.push({ text: "Marks", value: "exM_MARKS", width: "100px" });
      this.headers.push({
        text: "Type",
        value: "entryType",
        width: "200px",
      });      
      this.headers.push({
        text: "Last Attempt Date",
        value: "last_Attempt_Date",
        width: "200px",
      });      

    }

    if (this.fromDashboard != null) {
      this.fromDate = new Date(this.calenderselecteddate);
      this.toDate = new Date(this.calenderselecteddate);
      this.showData();
    } else {
      if (!this.selectedfromdate) {
        this.getDefaultDate();
      } else {
        this.fromDate = new Date(this.selectedfromdate);
        this.toDate = new Date(this.selectedtodate);
        this.showData();
      }
    }
  },
  mounted() {},
  updated() {
    //this.closeAll();
    //this.closeAll1();
  },
  computed: {
    apiUrl: get("app/apiUrl"),
    userid: get("user/id"),
    menuid: get("user/menuid"),

    selectedfromdate: sync("app/timetablefromdate"),
    calenderselecteddate: get("app/calenderselecteddate"),
    fromDashboard: sync("app/fromDashboard"),
    selectedtodate: sync("app/timetabletodate"),
    selecteduserid: get("app/selecteduserid"),
  },
  watch: {
    switchmobilebreakpoint: function(value) {
      if (value === true) this.mobilebreakpoint = "600";
      else this.mobilebreakpoint = "200";
    },
  },
  methods: {
    formatDate,
    getParameter() {
      const self = this;
      const fromDate = new Date(self.fromDate).toJSON();
      const toDate = new Date(self.toDate).toJSON();
      const data = {
        fromDate: fromDate,
        uptoDate: toDate,
      };
      return data;
    },
    getDefaultDate() {
      const self = this;
      axios({
        url: self.apiUrl + "api/Common/getTodayToWeek",

        method: "GET",
        responseType: "json",
      }).then(function(response) {
        self.fromDate = moment(new Date(response.data.fromDate)).format(
          "YYYY-MM-DD"
        );
        self.toDate = moment(new Date(response.data.toDate)).format(
          "YYYY-MM-DD"
        );

        self.showData();
      });
    },
    showData() {
      const self = this;
      if (self.fromDashboard == null) {
        self.selectedfromdate = self.fromDate;
        self.selectedtodate = self.toDate;
      }
      self.tableLoading = true;
      const data = self.getParameter();
      axios({
        url: self.apiUrl + "api/TimeTable/timetable",
        data: data,
        method: "POST",
        responseType: "json",
      })
        .then(function(res) {
          self.legendData = res.data.legends;

          self.listingActive = res.data.data.filter(
            (item) => item.type.toLowerCase() === "active"
          );

          self.listingCompleted = res.data.data.filter(
            (item) => item.type.toLowerCase() === "completed"
          );
          self.listingMissed = res.data.data.filter(
            (item) => item.type.toLowerCase() === "missed"
          );
          self.listingPending = res.data.data.filter(
            (item) => item.type.toLowerCase() === "pending"
          );
          axios({
            url: self.apiUrl + "api/Common/getToday",

            method: "GET",
            responseType: "json",
          }).then(function(response) {
            const today = moment(new Date(response.data.today)).format(
              "YYYY-MM-DD"
            );

            const fromdate = moment(self.fromDate).format("YYYY-MM-DD");
            const todate = moment(self.toDate).format("YYYY-MM-DD");
            if ((today >= fromdate && today <= todate) || fromdate > today) {
              self.tab = 0;
            } else self.tab = 1;
          });
          self.tableLoading = false;
          self.hiddenPDF = false;
        })
        .catch(function(err) {
          self.hiddenPDF = true;
          self.tableLoading = false;
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },
    row_classes(item) {
      console.log(item.rowcolor.toLowerCase());
      return item.rowcolor.toLowerCase();
    },
    toggleAll() {
      if (this.isExpanded) this.closeAll();
      else this.openAll();
    },
    closeAll() {
      this.isExpanded = false;
      Object.keys(this.$refs).forEach((k) => {
        if (this.$refs[k] && this.$refs[k].$attrs["data-open"]) {
          this.$refs[k].$el.click();
        }
      });
    },
    openAll() {
      this.isExpanded = true;
      Object.keys(this.$refs).forEach((k) => {
        if (this.$refs[k] && !this.$refs[k].$attrs["data-open"]) {
          this.$refs[k].$el.click();
        }
      });
    },
    closeAllFirst() {
      this.closeAll();
    },
    downloadfile(fileName, fileType) {
      axios
        .get(this.apiUrl + "api/Download/GetPDF/" + fileName + "/" + fileType, {
          responseType: "blob", // had to add this one here
        })
        .then((response) => {
          const content = response.headers["content-type"];
          download(response.data, fileName, content);
        })
        .catch((error) => console.log(error));
    },
  },
  beforeDestroy() {
    this.fromDashboard = null;
  },
};
</script>
